import { Box, styled } from '@mui/material';

export const Overlay = styled(Box)(({ theme }) => ({
  position: 'absolute',
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  zIndex: 1100,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  pointerEvents: 'auto',
  backgroundColor: 'rgba(255,255,255,0.3)',
  backdropFilter: 'blur(6px)'
}));
